import script from "./Adjustment.vue?vue&type=script&setup=true&lang=js"
export * from "./Adjustment.vue?vue&type=script&setup=true&lang=js"

import "./Adjustment.vue?vue&type=style&index=0&id=04211ccb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04211ccb"]])

export default __exports__